import { Pipe, PipeTransform } from "@angular/core";
import dayjs from "dayjs";

@Pipe({
  name: "isoDuration",
  standalone: false,
})
export class IsoDurationPipe implements PipeTransform {
  transform(value: string): string {
    try {
      if (!value) return "-";
      const d = dayjs.duration(value);
      return (
        (d.hours() > 0 ? `${d.hours()}h ` : "") +
        `${d.minutes()}m ${Math.round(d.seconds())}s`
      );
    } catch {
      return "-";
    }
  }
}
